module.exports = {
  en: {
    ERR_KAKAO_EXPIRED_OR_INVALID_REFRESH_TOKEN: 'Error occured. Please retry later.',
    // ERR_SNAPCHAT_LIFETIME_BUDGET_MINIMUM_REQUIREMENT: 'Lifetime budget should be at least $ ${minimumBudget}.00'
    ERR_APPLE_DAILY_BUDGET_TOO_HIGH: 'Daily Budget is higher than Total Budget', // original message is like Daily Budget, 20.0 USD, is higher than Total Budget, 10.0 USD'

    // Yahoo
    INVALID_SEARCH_BUDGET_VALUE: 'New budget must be at least 1 time(s) your desired bid for a Search campaign.',
    INVALID_NATIVE_BUDGET_VALUE: 'New budget must be at least 50 times your desired bid for a Native campaign.',
  },
  ko: {
    ERR_KAKAO_EXPIRED_OR_INVALID_REFRESH_TOKEN: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    // ERR_SNAPCHAT_LIFETIME_BUDGET_MINIMUM_REQUIREMENT: 'Lifetime budget이 최소 $ ${minimumBudget}.00 이어야 합니다'
    ERR_APPLE_DAILY_BUDGET_TOO_HIGH: 'Daily Budget is higher than Total Budget', // original message is like Daily Budget, 20.0 USD, is higher than Total Budget, 10.0 USD'

    // Yahoo
    INVALID_SEARCH_BUDGET_VALUE: '검색 캠페인의 예산은 입찰 단가의 1배 이상이여야 합니다.',
    INVALID_NATIVE_BUDGET_VALUE: '네이티브 캠페인의 예산은 입찰 단가의 50배 이상이여야 합니다.',
  },
};
